module.exports = __webpack_public_path__ + "static/media/security.c69ce4ca.png";